import { useCallback } from 'react';

import { useLocalforage } from '@/hooks/use-localforage';

export const TRACKING_CODE_KEY = 'tracking-code';

export function useTrackingCode() {
  const {
    values: [tracking],
    setItem,
    store,
  } = useLocalforage<[string]>([TRACKING_CODE_KEY]);
  const setTracking = useCallback((code: string) => setItem(TRACKING_CODE_KEY, code), [setItem]);

  return { tracking, setTracking, isReady: !!store };
}
